import { ReactComponent as World } from '@quick/assets/illustrations/world.svg';

import { useFormDataContext } from './FormDataContext';

export function Background() {
  const { serviceType } = useFormDataContext();
  if (serviceType) return null;
  return (
    <World
      className="-translate-x-1/7 pointer-events-none fixed bottom-0 h-full fill-gray-300 pb-8
        pt-24 text-yellow-400 sm:left-1/2 sm:-translate-x-1/2 dark:fill-gray-600
        dark:text-yellow-300 [&_circle]:opacity-50"
    />
  );
}
